import { addOpenTradeApi } from "../components/constant/api";
import { myApi } from "./api";

export const placeOrderApi = myApi.injectEndpoints({
  endpoints: (builder) => ({
    setOpenTrade: builder.mutation({
      query: (post) => ({
        url: addOpenTradeApi,
        method: "POST",
        body:post
      }),
      invalidatesTags: (_) => ["tradehistory"],
    }),
  }),
});

export const {useSetOpenTradeMutation}=placeOrderApi